const theme = {
  colors: {
    $p0: '#393abd',
    $p1: '#445CCC',
    $p2: '#777E91',
    $p3: '#B1B5C4',
    $p4: 'rgba(57, 58, 189, 0.1)',
    $p5: '#F4F6F9',
    $p6: '#FFFFFF',
    $p7: '#181A20',
    $p8: '#FFB27D',
    $p9: '#2148FF',
    $p10: '#152946',
    $s1: '#F84B7A',
    $s2: '#32D7BE',
    $b1: '#EAECEF',
    $n1: '#161643',
    $n3: '#353945',
    $n4: '#6B6B95',
    $n5: '#9696B9',
    $n6: '#B1B5C4',
    $n7: '#E6E8EC',
    $cp1: '#181A20',
    $cp2: 'rgba(9, 16, 29, 0.75)',
    $fontBlack: '#101828',
    $mainColor: '#385bf8',
  },
  fontSizes: {
    $small: '14px',
    $medium: '16px',
    $large: '18px',
    $largeXL: '22px',
    $big: '24px',
  },
  gradients: {
    $g0: 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), radial-gradient(50% 50% at 50% 50%, #5573FF 0%, #4441E9 100%)',
    $g1: 'radial-gradient(50% 50% at 50% 50%, #BEC2D6 0%, #A8ADC7 100%)',
    $g2: 'radial-gradient(50% 50% at 50% 50%, #878D9C 0%, #6A7287 100%)',
    $mainButton: 'linear-gradient(180deg, #385BF8 0%, #2148FF 100%)',
  },
};

export {theme};
